import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Input, Select, Tag, Avatar, Button, Table, Modal, Empty, Alert } from 'antd';
import config from "../../config.json";
import axios from 'axios';
import utils from '../utils/index';
import { SearchOutlined, CheckCircleOutlined } from '@ant-design/icons';
import MathTableData from './MathTableData'
import EngTableData from './EngTableData'
import ParentAudit from "./parentData";
import CardData from './CardData';

const innerwidth = window.innerWidth;
const { Option } = Select;
const date = new Date();
let year = date.getFullYear();
let month = ("0" + (date.getMonth() + 1)).slice(-2);
let day = ("0" + date.getDate()).slice(-2);
let today = `${year}-${month}-${day}`;
let temp = `${year}-${month}`;
let dateday = ("0" + date.getDate()).slice(-2);

const tableColumns = [
  {
    title: 'RM Name',
    dataIndex: 'RM_Name',
    key: 'RM_Name',
    render: (text, record) => (
      <div className="d-flex align-items-center">
        <Avatar size={30} className="font-size-sm" style={{ backgroundColor: '#04d182' }}>
          {utils.getNameInitial(text)}
        </Avatar>
        <span className="ml-2">{text}</span>
      </div>
    ),
    sorter: (a, b) => utils.antdTableSorter(a, b, 'RM_Name')
  },
  {
    title: 'RM Code',
    dataIndex: 'RMcode',
    key: 'RMcode',
    sorter: (a, b) => utils.antdTableSorter(a, b, 'RMcode')
  },
  {
    title: 'Reason',
    dataIndex: 'Reason',
    key: 'Reason',
    sorter: (a, b) => utils.antdTableSorter(a, b, 'Reason')
  },
  {
    title: () => <div className="text-right">Status</div>,
    key: 'Status',
    render: (_, record) => (
      <div className="text-right">
        <Tag className="mr-0" color={record.Status === 'Present' ? 'cyan' : record.Status === 'Absent' ? 'volcano' : 'blue'}>{record.Status}</Tag>
      </div>
    ),
    sorter: (a, b) => utils.antdTableSorter(a, b, 'Status')
  },
];
const CentralAudit = () => {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [apiError, setapiError] = useState(null);
  const cl = localStorage.getItem("CL");
  const [val] = useState('Select');
  const [data, setData] = useState([]);
  const [RMCode, setRMCode] = useState("");
  const [RMMathAuditDone, setRMMathAuditDone] = useState(false);
  const [RMEngAuditDone, setRMEngAuditDone] = useState(false);
  const [ParentAuditDone, setParentAuditDone] = useState(false);
  const [RMData, setRMData] = useState([]);//RM for Today
  const [tableDataRMs, setTableDataRMs] = useState([]);
  const [alltableDataRMs, setAllTableDataRMs] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showTableHeading, setshowTableHeading] = useState("Audit");
  const [showScoreData, setShowScoreData] = useState(false);
  const [mathParentdata, setMathParentData] = useState([]);
  const [engParentdata, setEngParentData] = useState([]);
  const [showParent, setshowParent] = useState(false);
  const [subject, setSubject] = useState('');
  const [englishAlert, setEnglishAlert] = useState(false)
  const [mathAlert, setMathAlert] = useState(false)
  const [noRMAlert, setNoRMAlert] = useState(false)

  useEffect(() => {
    async function fetchData() {
      getabsent();
      RMMathAudit();
      AllCL()
    }
    fetchData();
  }, []);

  async function getRMForToday() {
    let url = config.getRM + cl;
    await axios.get(url, { headers: { 'Authorization': token } })
      .then(resp => {

        setNoRMAlert(true)
        if (resp.data.status === "error") setapiError(resp.data);
        if (resp.data.length > 0) {
          setRMData(resp.data);
          if (resp.data[0].rmauditpercent)
            setRMMathAuditDone(true);
          if (resp.data[0].RMAuditPercentEnglish)
            setRMEngAuditDone(true);
          if (resp.data[0].parentauditpercent)
            setParentAuditDone(true);
          setLoading(false)
        }
      }, error => {
        setapiError(error.response);
      });
  }

  async function getabsent() {
    let url1 = config.getabsentRMForAudit + cl;
    await axios.get(url1, { headers: { 'Authorization': token } })
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);
        setTableDataRMs(resp.data)
        setAllTableDataRMs(resp.data)
        getRMForToday();
      }, error => {
        setapiError(error.response);
      });
  }

  async function RMMathAudit() {
    let url1 = config.getRMMathsDataForNextFifteen + cl;
    let url2 = config.getRMAuditMathsData + cl;
    let url;


    if (dateday < 15) {
      url = url2;
    }
    else {

      url = url1;
    }


    await axios.get(url)
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);
        setMathParentData(resp.data);
        RMEngAudit()
      }, error => {
        setapiError(error.response);
      });
  }

  async function AllCL() {
    let listOfAllCLs = config.listOfAllCLs;
    axios.get(listOfAllCLs, { headers: { 'Authorization': token } })
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);
        else {
          setData(resp.data);
          setLoading(false);
        }
      }, err => {
        let obj = { "status": "error", "message": "Network Error" };
        if (err.response) setapiError(err.response);
        else setapiError(obj);
      });
  }
  async function RMEngAudit() {
    let url1 = config.getRMEngDataForNextFifteen + cl;
    let url2 = config.getRMAuditEngData + cl;

    let url;

    if (dateday < 15) {
      url = url2;
    }
    else {
      url = url1;
    }

    await axios.get(url)
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);

        setEngParentData(resp.data)
        getabsent();
      })
      .catch(err => {
        setapiError(err.response);
      });

  }

  const onSearch = e => {
    const value = e.currentTarget.value;
    const searchdata = utils.wildCardSearch(alltableDataRMs, value)
    setTableDataRMs(searchdata);
  }

  const showTableData = (str) => {
    if (str === 'Math') {
      setMathAlert(true)
      setSubject(str)
      setRMCode(RMData[0].rmcode)
      setshowTableHeading("RM Maths Audit")
      setshowTable(true)
    }
    else {
      setEnglishAlert(true)
      setSubject(str)
      setRMCode(RMData[0].RMcodeEnglish)
      setshowTableHeading("RM English Audit")
      setshowTable(true)
    }
  }

  const showParentAudit = () => {
    setshowTableHeading("Parent Audit")
    setshowParent(!showParent);
  }

  const showScore = () => {
    setShowScoreData(!showScoreData);
  }



  const onSelect = (e) => {
    localStorage.setItem("CL", e);
    window.location = '/omPortal/app/CentralAudit'
  }
  const onClose = () => {
    localStorage.setItem("");
    window.location = '/omPortal/app/CentralAudit'
  };
  return (
    <>
      <Card>
        <Row>
          <Col span={6} style={{ margin: '5px' }}>
            <h1> Choose CL</h1>
          </Col>
          <Col span={6}>
            {RMData.length > 0 ? <Select
              style={{ width: '90%' }}
              placeholder='Select'
              defaultValue={val}
              onChange={onSelect}
            >
              {data.map(elm => <Select.Option key={elm} value={elm}>{elm}</Select.Option>)}
            </Select> :
              <Select
                style={{ width: '90%' }}
                placeholder='Select'
                defaultValue={val}
                onChange={onSelect}
                disabled

              >
                {data.map(elm => <Select.Option key={elm} value={elm}>{elm}</Select.Option>)}
              </Select>
            }

          </Col>
        </Row>
      </Card>

      <Card className='text-center'>
        <Row className='text-center'>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <h3>{showTableHeading}</h3>
          </Col>
        </Row>
      </Card>
      {englishAlert && engParentdata.length === 0 ? <Alert
        message="Warning"
        description="No Parent Data Found for English Audit."
        type="warning"
        showIcon
        details={englishAlert}
      />
        :
        ""}
      {mathAlert && mathParentdata.length === 0 ? <Alert
        message="Warning"
        description="No Parent Data Found for Maths Audit."
        type="warning"
        showIcon
        details={mathAlert}
      />
        :
        ""}
      {noRMAlert && RMData === "No data found for setrm" ? <Alert
        message="Warning"
        description="No Data Found for This CL. Please Select Another CL"
        type="warning"
        showIcon
        details={noRMAlert}
        closable
        onClose={onClose}
      />
        :
        ""}
      {
        showTable ?
          subject === 'English' ?
            engParentdata.length === 0 ?
              (
                window.location = "/omPortal/app/CentralAudit"
              )
              :
              (
                innerwidth > 425 ?
                  <EngTableData
                    parentdata1={engParentdata}
                    RMCode={RMCode}
                    subject={subject}
                    onChangeHeading={() => setshowTableHeading("Audit")}
                  />
                  :
                  <EngTableData
                    parentdata1={engParentdata}
                    RMCode={RMCode}
                    subject={subject}
                    onChangeHeading={() => setshowTableHeading("Audit")}
                  />
              )
            :
            mathParentdata.length === 0 ? (
              window.location = "/omPortal/app/CentralAudit")
              :
              (innerwidth > 425 ? <MathTableData
                parentdata1={mathParentdata}
                RMCode={RMCode}
                subject={subject}
                onChangeHeading={() => setshowTableHeading("Audit")}
              />
                :
                <MathTableData parentdata1={mathParentdata}
                  RMCode={RMCode}
                  subject={subject}
                  onChangeHeading={() => setshowTableHeading("Audit")} />
              )
          :
          showParent && cl ?
            <ParentAudit
              RMCode={RMData.length > 0 ? RMData[0].rmcode : ""}
            />
            :
            <>
              <Row gutter={[4, 4]}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>

                  <Row gutter={[4, 4]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Card title={"RM Audit"}>
                        <Row>

                          <Col xs={24} sm={24} md={18} lg={18} xl={18} xxl={18}>
                            <h3>RMCode for Maths :{RMData.length > 0 ? RMData[0].rmcode : "No RM Selected"}</h3>
                            <p><b>RM Maths ऑडिट के  लिए यहाँ क्लिक करे ।</b></p>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                            {RMMathAuditDone ?
                              <CheckCircleOutlined style={{ color: '#36cfc9', fontSize: 60 }} />
                              :
                              <Button type='primary' onClick={() => showTableData("Math")}>Click here!</Button>
                            }
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                  {(cl === "7" || cl === "17") ?

                    <Row gutter={[4, 4]}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <Card title={"RM Audit"} >
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={18} xl={18} xxl={18}>
                              <h3>RMCode for English : {RMData.length > 0 ? RMData[0].RMcodeEnglish : "No RM Selected"}</h3>
                              <p><b>RM English ऑडिट के  लिए यहाँ क्लिक करे ।</b></p>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                              {RMEngAuditDone ?
                                <CheckCircleOutlined style={{ color: '#36cfc9', fontSize: 60 }} />
                                :
                                <Button type='primary' onClick={() => showTableData("English")}>Click here!</Button>
                              }
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                    : ""}

                  <Row gutter={[4, 4]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Card title={"Parent Audit"} >
                        <Row>
                          <Col xs={24} sm={24} md={24} lg={18} xl={18} xxl={18}>
                            <h3>RMCode for Parent Audit : {RMData.length > 0 ? RMData[0].rmcode : "No RM Selected"}</h3>
                            <p><b>Parent ऑडिट के  लिए यहाँ क्लिक करे ।</b></p>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                            {ParentAuditDone ?
                              <CheckCircleOutlined style={{ color: '#36cfc9', fontSize: 60 }} />
                              :
                              <Button type='primary' onClick={() => showParentAudit()}>Click here!</Button>
                            }
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                  <Row gutter={[4, 4]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Card title={"Audit Score"} >
                        <Row>
                          <Col xs={24} sm={24} md={24} lg={18} xl={18} xxl={18}>
                            <p><b>Score के  लिए यहाँ क्लिक करे ।</b></p>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                            <Button type="primary" onClick={showScore}>Click here!</Button>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>

                  <Row gutter={[4, 4]}>
                  </Row>
                </Col>

                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                  {
                    innerwidth > 425 ?
                      <Card title="Unavailable RMs" style={{ height: 830 }}>
                        <Input placeholder="Search" style={{ width: '100%' }} prefix={<SearchOutlined />} onChange={e => onSearch(e)} />
                        {tableDataRMs.length > 0 ?
                          <Table
                            className="no-border-last"
                            columns={tableColumns}
                            dataSource={tableDataRMs}
                            rowKey='RM_code'
                            style={{ overflowY: 'scroll', height: 590 }}
                            pagination={false}
                          />
                          : <Empty />}
                      </Card>
                      :
                      <Card title="Unavailable RMs" style={{ height: 'auto' }}>
                        <Input placeholder="Search" style={{ width: '100%' }} prefix={<SearchOutlined />} onChange={e => onSearch(e)} />
                        {tableDataRMs.length > 0 ? <CardData data={tableDataRMs} /> : <Empty />}
                      </Card>
                  }
                </Col>
              </Row>

              <Modal
                title="Audit Score"
                visible={showScoreData}
                onOk={showScore}
                cancelButtonProps={{ hidden: true }}
                onCancel={() => setShowScoreData(false)}>
                <Row gutter={[4, 4]}>
                  <Col xs={14} sm={14} md={14} lg={12} xl={12} xxl={12}>
                    <h4>Math RM Audit : </h4>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={12} xl={12} xxl={12}>
                    <Tag className="mr-0" color={RMData.length > 0 ? RMData[0].rmauditpercent ? 'cyan' : 'volcano' : "blue"}>{RMData.length > 0 ? RMData[0].rmauditpercent ? RMData[0].rmauditpercent : "Pending" : "Pending"}</Tag>
                  </Col>
                </Row>
                {(cl === "7" || cl === "17") ?
                  <Row gutter={[4, 4]}>
                    <Col xs={14} sm={14} md={14} lg={12} xl={12} xxl={12}>
                      <h4>English RM Audit : </h4>
                    </Col>
                    <Col xs={10} sm={10} md={10} lg={12} xl={12} xxl={12}>
                      <Tag className="mr-0" color={RMData.length > 0 ? RMData[0].RMAuditPercentEnglish ? 'cyan' : 'volcano' : "blue"}>{RMData.length > 0 ? RMData[0].RMAuditPercentEnglish ? RMData[0].RMAuditPercentEnglish : "Pending" : "Pending"}</Tag>
                    </Col>
                  </Row>
                  : ""}
                <Row gutter={[4, 4]}>
                  <Col xs={14} sm={14} md={14} lg={12} xl={12} xxl={12}>
                    <h4>Parent Audit : </h4>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={12} xl={12} xxl={12}>
                    <Tag className="mr-0" color={RMData.length > 0 ? RMData[0].parentauditpercent ? 'cyan' : 'volcano' : "blue"}>{RMData.length > 0 ? RMData[0].parentauditpercent ? RMData[0].parentauditpercent : "Pending" : "Pending"}</Tag>
                  </Col>
                </Row>
              </Modal>
            </>
      }
    </>
  )
}



export default CentralAudit;